import { LayoutRenderLayoutItemOptions } from '../../../models/cv-layout-render.model';

export class RoomLayoutOptions extends LayoutRenderLayoutItemOptions {
	header?: RoomLayoutHeader;
	schemaVersion?: string;
	bodyCssClass?: string;

	constructor() {
		super();
		this.header = new RoomLayoutHeader();
		this.schemaVersion = 'v34';
		this.bodyCssClass = '';
	}
}

export class RoomLayoutHeader {
	key?: string;
	value?: string;

	constructor() {
		this.key = 'description';
		this.value = null;
	}
}